import { Component } from '@angular/core'
import { StrHlp } from 'src/app/shared/services/StringGetter/getstring.service'
import { SeoHelperService } from 'src/app/shared/services/seo/seo-helper.service'

@Component({
  selector: 'app-statisticspage',
  templateUrl: './statisticspage.component.html',
  styleUrls: [
    './statisticspage.component.css',
    '../versionhistory/versionhistory.component.css'
  ]
})
export class StatisticspageComponent {
  constructor(
    public strHlp: StrHlp,
    private seoHelper: SeoHelperService
  ) {}

  ngOnInit(): void {
    this.seoHelper.setForSomePage('Statistics', 'Statistics')
  }
}
